import { Route, Routes, Outlet } from "react-router-dom";
import UnassignedTabs from "./UnassignedTabs";
import RecentTab from "./RecentTab";
import TodayTab from "./TodayTab";
import SLBreachedTab from "./SLBreachedTab";
// 

const ActivityRoutes = () => {
  return (
    <div
      id="kt_app_content_container"
      className="app-container mx-5"
      style={{ overflow: "hidden" , width:'100%' }}
    >
      <div className="card card-flush">
        <div className="d-flex flex-column pt-1 px-5 pb-5">
          <Routes>
            <Route element={<Outlet />}>
              <Route path="active" element={<TodayTab />} />
              <Route path="recent" element={<RecentTab />} />
              <Route path="unassigned" element={<UnassignedTabs />} />
              <Route path="sl-breached" element={<SLBreachedTab />} />
            </Route>
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default ActivityRoutes;
